import {userHovercardPath} from '@github-ui/paths'
import {ProfileReference} from '@github-ui/profile-reference'
import {Link} from '@primer/styled-react'
import {graphql, useFragment} from 'react-relay'

import {VALUES} from '../constants/values'
import type {IssueBodyHeaderAuthor$key} from './__generated__/IssueBodyHeaderAuthor.graphql'
import styles from './IssueBodyHeaderAuthor.module.css'

export function IssueBodyHeaderAuthor({author}: {author: IssueBodyHeaderAuthor$key | null; showLogin?: boolean}) {
  const data = useFragment(
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    graphql`
      fragment IssueBodyHeaderAuthor on Actor {
        login
        profileUrl
        ... on User {
          name
        }
        ... on EnterpriseUserAccount {
          name
        }
        ... on Mannequin {
          name
        }
      }
    `,
    author,
  )

  const {login, name, profileUrl} = data || VALUES.ghost
  return (
    <Link
      href={profileUrl || undefined}
      data-hovercard-url={profileUrl && userHovercardPath({owner: login})}
      data-testid="issue-body-header-author"
      sx={{
        ':hover': {
          textDecoration: profileUrl ? 'underline' : 'none',
        },
      }}
      className={styles.authorLoginLink}
    >
      <ProfileReference login={login} profileName={name} isAgent={false} />
    </Link>
  )
}
